import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, Stack, Typography } from '@mui/joy';

import { TextInputField } from '../FormElements/TextInputField';

interface DeviceUuidFormProps {
  onSubmit: (deviceUuid: string) => void;
  loading?: boolean;
}

export default function DeviceUuidForm({ onSubmit, loading }: DeviceUuidFormProps) {
  const { t } = useTranslation();
  const [deviceUuid, setDeviceUuid] = useState('');
  const [touched, setTouched] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setTouched(true);
    if (deviceUuid.trim()) {
      onSubmit(deviceUuid.trim());
    }
  };

  const hasError = touched && !deviceUuid.trim();

  return (
    <Box component='form' onSubmit={handleSubmit} sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
      <Stack spacing={2}>
        <Typography level='h3'>{t('register_device.enter_device_uuid')}</Typography>
        <TextInputField
          error={hasError ? t('register_device.device_uuid_required') : ''}
          label={t('devices.device_uuid')}
          name='deviceUuid'
          onChange={(e) => setDeviceUuid(e.target.value)}
          required
          value={deviceUuid}
        />
        <Button loading={loading} type='submit' variant='solid'>
          {t('register_device.submit')}
        </Button>
      </Stack>
    </Box>
  );
}
